export const environment = {
  name: 'qa',
  production: false,
  // Switch to internal once Stage public environment is ready https://hr-api.qa.intern.smartwork.ro
  backendServiceUrl: 'https://hr-api-qa.smartwork.ro',
  backendApiContext: 'hr/api/v1',
  documentMangerServiceUrl: 'https://dm-api-qa.gits.ro',
  documentMangerApiContext: 'dm/api/v1',
  language: 'ro-RO',
  features: {
    dateTimeIntervals: 'relative', // "distance", "relative", "datetime"
    languages: ['ro-RO', 'en-GB']
  }
};
